import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import formatMoney from '../utils/formatMoney.js';
import FormText from './FormText.js';
import FormTextArea from './FormTextArea.js';
import FormDate from './FormDate.js';
import validateEmail from '../utils/validateEmail.js';
import validateRestorePassword from '../utils/validateRestorePassword.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function UserEdit({showEdit, closeEdit, updateUserRow, data, usrInfo}) {
	const popupAnimationMs = 300;
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [savingUnpaidKey, setSavingUnpaidKey] = useState('');
	const [username, setUsername] = useState('');
	const [usernameError, setUsernameError] = useState('');
	const [firstName, setFirstName] = useState('');
	const [firstNameError, setFirstNameError] = useState('');
	const [lastName, setLastName] = useState('');
	const [lastNameError, setLastNameError] = useState('');
	const [nickname, setNickname] = useState('');
	const [nicknameError, setNicknameError] = useState('');
	const [phone, setPhone] = useState('');
	const [phoneError, setPhoneError] = useState('');
	const [prefix, setPrefix] = useState('');
	const [prefixError, setPrefixError] = useState('');
	const [password, setPassword] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [password2, setPassword2] = useState('');
	const [passwordError2, setPasswordError2] = useState('');
	const [accountNumber, setAccountNumber] = useState('');
	const [accountNumberError, setAccountNumberError] = useState('');
	const [topayTotal, setTopayTotal] = useState('');
	const [topayTotalError, setTopayTotalError] = useState('');
	const [payedtoDT, setPayedtoDT] = useState('');
	const [payedtoDTError, setPayedtoDTError] = useState('');
	const [message, setMessage] = useState('');
	const [messageError, setMessageError] = useState('');
	const [parentPromoCode, setParentPromoCode] = useState('');
	const [parentPromoCodeError, setParentPromoCodeError] = useState('');
	const [instructor, setInstructor] = useState(0);
	const [sysadmin, setSysadmin] = useState(0);
	const [manager, setManager] = useState(0);
	const [permanent, setPermanent] = useState(0);
	const [entryPriceOne, setEntryPriceOne] = useState('');
	const [entryPriceOneError, setEntryPriceOneError] = useState('');

	const usernameRef = useRef();
	const firstNameRef = useRef();
	const lastNameRef = useRef();
	const nicknameRef = useRef();
	const phoneRef = useRef();
	const prefixRef = useRef();
	const passwordRef = useRef();
	const passwordRef2 = useRef();
	const accountNumberRef = useRef();
	const topayTotalRef = useRef();
	const payedtoDTRef = useRef();
	const messageRef = useRef();
	const parentPromoCodeRef = useRef();
	const entryPriceOneRef = useRef();
	const {shouldRender, isClosing} = usePopupAnimation(showEdit, popupAnimationMs);

	useEffect(() => {
		setPassword('');
		setPassword2('');
	}, [showEdit]);

	useEffect(() => {
		setUsername(data.EMAIL || '');
		setFirstName(data.FIRSTNAME || '');
		setLastName(data.LASTNAME || '');
		setNickname(data.NICKNAME || '');
		setPhone(data.PHONE_NUMBER || '');
		setPrefix(data.PHONE_PREFIX || '');
		setPassword('');
		setPassword2('');
		setAccountNumber(data.ACCOUNTNUMBER || '');
		setTopayTotal(data.TOPAY_TOTAL || 0);
		setPayedtoDT(data.PAYEDTO_DT || '');
		setMessage((data.MESSAGE || '').replace(/<br\s*\/?>/gi, '\n'));
		setParentPromoCode(data.PARENT_PROMO_CODE || '');
		setInstructor(data.INSTRUCTOR || 0);
		setSysadmin(data.SYSADMIN || 0);
		setManager(data.MANAGER || 0);
		setPermanent(parseInt(data.PERNAMENTMEMBER) || 0);
		setEntryPriceOne(data.ENTRY_PRICE_ONE > -1 ? data.ENTRY_PRICE_ONE : '');

		setUsernameError('');
		setFirstNameError('');
		setLastNameError('');
		setNicknameError('');
		setPhoneError('');
		setPrefixError('');
		setPasswordError('');
		setPasswordError2('');
		setAccountNumberError('');
		setTopayTotalError('');
		setPayedtoDTError('');
		setMessageError('');
		setParentPromoCodeError('');
		setEntryPriceOneError('');
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setUsernameError('');
		setFirstNameError('');
		setLastNameError('');
		setNicknameError('');
		setPhoneError('');
		setPrefixError('');
		setPasswordError('');
		setPasswordError2('');
		setAccountNumberError('');
		setTopayTotalError('');
		setPayedtoDTError('');
		setMessageError('');
		setParentPromoCodeError('');
		setEntryPriceOneError('');

		let localError = 0;

		if (!username) {
			localError = 1;
			setUsernameError('povinné');
			usernameRef.current.focus();
		} else if (!validateEmail(username)) {
			localError = 1;
			setUsernameError('Neplatný email');
			usernameRef.current.focus();
		}

		if (!firstName) {
			if (localError === 0) {
				firstNameRef.current.focus();
			}
			localError = 1;
			setFirstNameError('povinné');
		}

		if (!lastName) {
			if (localError === 0) {
				lastNameRef.current.focus();
			}
			localError = 1;
			setLastNameError('povinné');
		}

		if (!prefix) {
			if (localError === 0) {
				prefixRef.current.focus();
			}
			localError = 1;
			setPrefixError('*');
		}

		if (!phone || phone.length < 9) {
			if (localError === 0) {
				phoneRef.current.focus();
			}
			localError = 1;
			setPhoneError('*');
		}

		if (password !== '') {
			const sError = validateRestorePassword(password, password2);
			setPasswordError(sError.password);
			setPasswordError2(sError.password2);

			if (sError.password !== '') {
				if (localError === 0) {
					passwordRef.current.focus();
				}
				localError = 1;
			}

			if (sError.password2 !== '') {
				if (localError === 0) {
					passwordRef2.current.focus();
				}
				localError = 1;
			}
		}

		if (localError === 0) {
			setIsSubmitting(true);

			post('saveUser', {username, firstName, lastName, nickname, phone, prefix, password, password2, accountNumber, topayTotal, payedtoDT, message, id: data.ID, parentPromoCode, instructor, sysadmin, manager, entryPriceOne})
				.then((res) => {
					if (parseInt(res.data) === 1) {
						closeEdit();
						updateUserRow(username, firstName, lastName, nickname, phone, prefix, data.ID, message, payedtoDT, topayTotal, instructor, sysadmin, manager, entryPriceOne);
					}

					setIsSubmitting(false);
				})
				.catch((error) => {
					console.error(error);
					setIsSubmitting(false);
				});
		}
	};

	const saveReservationPayed = (index, id, val, dt) => {
		const unpaidKey = `reservation-${id}`;

		if (savingUnpaidKey) {
			return;
		}

		setSavingUnpaidKey(unpaidKey);

		post('saveReservationPayed', {ID: id, PAYED: val})
			.then((res) => {
				data.not_payed_add_person[index].PAYED = res.data;

				if (permanent === 0) {
					setPayedtoDT(dt);
				}

				setSavingUnpaidKey('');
			})
			.catch((error) => {
				console.error(error);
				setSavingUnpaidKey('');
			});
	};

	const saveAddPersonPayed = (e, index2, id, val, type) => {
		e.preventDefault();
		const unpaidKey = `add-person-${id}`;

		if (savingUnpaidKey) {
			return;
		}

		setSavingUnpaidKey(unpaidKey);

		post('saveAddPersonPayed', {ID: id, ADD_PERSON_PAYED: val, TYPE: type})
			.then((res) => {
				data.not_payed_add_person[index2].ADD_PERSON_PAYED = res.data;
				setSavingUnpaidKey('');
			})
			.catch((error) => {
				console.error(error);
				setSavingUnpaidKey('');
			});
	};

	const setInstructorVal = (e) => {
		e.preventDefault();

		setInstructor((oldValue) => {
			if (instructor === 1) {
				return 0;
			} else {
				return 1;
			}
		});
	};

	const setSysadminVal = (e) => {
		e.preventDefault();

		setSysadmin((oldValue) => {
			if (sysadmin === 1) {
				return 0;
			} else {
				return 1;
			}
		});
	};

	const setManagerVal = (e) => {
		e.preventDefault();

		setManager((oldValue) => {
			if (manager === 1) {
				return 0;
			} else {
				return 1;
			}
		});
	};

	// Krok pro tlačítka u dluhu = cena jednorázového vstupu (vlastní cena uživatele, jinak cena z ceníku)
	const parsePrice = (val) => {
		const num = parseFloat(`${val ?? ''}`.replace(/\s/g, '').replace(',', '.'));
		return Number.isNaN(num) ? 0 : num;
	};
	const userEntryPriceOne = `${entryPriceOne ?? ''}`.trim() !== '' ? parsePrice(entryPriceOne) : -1;
	const topayStep = userEntryPriceOne > -1 ? userEntryPriceOne : parsePrice(usrInfo.ENTRY_PRICE_ONE);
	const topayInsertValues = topayStep > 0 ? ['0', `-${topayStep}`, `+${topayStep}`] : ['0'];

	let listNotPayedAddPerson = [];
	let totalNotPayedAddPerson = 0;
	let totalNotPayerAddPersonPrices = 0;
	let totalNotPayedAddPersonFinished = 0;
	let totalNotPayerAddPersonFinishedPrices = 0;
	let totalNotPayedAddPersonPreviousMonth = 0;
	let totalNotPayerAddPersonPreviousMonthPrices = 0;

	const currentDate = new Date();
	let targetMonth = currentDate.getMonth() - 1;
	let targetYear = currentDate.getFullYear();

	if (targetMonth < 0) {
		targetMonth = 11; // Prosinec (v JS jsou měsíce indexovány 0-11)
		targetYear -= 1;
	}

	if (showEdit) {
		data.not_payed_add_person.forEach((line2, index2) => {
			const isFuture = parseInt(line2.IS_FUTURE) === 1;
			const isCompanionRow = parseInt(line2.TYPE) === 2;
			const showUserToggle = parseInt(line2.TYPE) === 1;
			const showCompanionToggle = parseInt(line2.ADD_PERSON) > 0;
			const reservationToggleKey = `reservation-${line2.ID}`;
			const addPersonToggleKey = `add-person-${line2.ID}`;
			const isReservationSaving = savingUnpaidKey === reservationToggleKey;
			const isAddPersonSaving = savingUnpaidKey === addPersonToggleKey;
			const userAmount = showUserToggle && parseInt(line2.PAYED) === 0 ? formatMoney(line2.NOT_PAYED_PRICES_USR) : formatMoney(0);
			const companionAmount = showCompanionToggle ? formatMoney(line2.NOT_PAYED_PRICES) : formatMoney(0);

			listNotPayedAddPerson.push(
				<div className={`user-page__edit-unpaid-row${isCompanionRow ? ' is-companion is-lock' : ' is-self'}`} key={`NOT_PAYED_ADD_PERSON${index2}`}>
					<div className="user-page__edit-unpaid-main txt_l">
						<span className={`user-page__edit-unpaid-title${isFuture ? ' is-future' : ''}`}>
							{line2.RESERVATIONDTS} - {line2.RESERVATIONLNG_H}h{line2.ADD_PERSON > 0 ? ` + ${line2.ADD_PERSON}x` : ''}
						</span>
						<div className="user-page__edit-unpaid-actions">
							<div className="user-page__edit-unpaid-cell">
								<span className="user-page__edit-unpaid-value">{userAmount}</span>
								{showUserToggle ? (
										<button type="button" className="user-page__edit-unpaid-toggle" onClick={() => saveReservationPayed(index2, line2.ID, line2.PAYED, line2.RESERVATIONDTS3)} disabled={isReservationSaving || savingUnpaidKey !== ''} aria-busy={isReservationSaving}>
										<img className={`icon1 ${parseInt(line2.PAYED) === 0 ? 'ok0' : 'ok1'} user-page__edit-unpaid-icon`} alt="" />
									</button>
								) : (
									<span className="user-page__edit-unpaid-toggle-spacer" aria-hidden="true"></span>
								)}
							</div>
							<div className="user-page__edit-unpaid-cell user-page__edit-unpaid-cell--accent">
								<span className="user-page__edit-unpaid-value user-page__edit-unpaid-value--accent">{companionAmount}</span>
								{showCompanionToggle ? (
										<button type="button" className="user-page__edit-unpaid-toggle" onClick={(e) => saveAddPersonPayed(e, index2, line2.ID, line2.ADD_PERSON_PAYED, line2.TYPE)} disabled={isAddPersonSaving || savingUnpaidKey !== ''} aria-busy={isAddPersonSaving}>
										<img className={`icon1 ${parseInt(line2.ADD_PERSON_PAYED) === 0 ? 'ok0' : 'ok1'} user-page__edit-unpaid-icon`} alt="" />
									</button>
								) : (
									<span className="user-page__edit-unpaid-toggle-spacer" aria-hidden="true"></span>
								)}
							</div>
						</div>
					</div>
				</div>
			);

			const reservationDate = new Date(line2.SORT_DT);

			if (parseInt(line2.ADD_PERSON_PAYED) === 0) {
				totalNotPayedAddPerson += parseInt(line2.ADD_PERSON);
				totalNotPayerAddPersonPrices += parseFloat(line2.NOT_PAYED_PRICES);

				if (parseInt(line2.IS_FUTURE) === 0) {
					totalNotPayedAddPersonFinished += parseInt(line2.ADD_PERSON);
					totalNotPayerAddPersonFinishedPrices += parseFloat(line2.NOT_PAYED_PRICES);
				}

				if (reservationDate.getMonth() === targetMonth && reservationDate.getFullYear() === targetYear) {
					totalNotPayedAddPersonPreviousMonth += parseInt(line2.ADD_PERSON || 0, 10);
					totalNotPayerAddPersonPreviousMonthPrices += parseFloat(line2.NOT_PAYED_PRICES || 0);
				}
			}

			if (parseInt(line2.PAYED) === 0) {
				++totalNotPayedAddPerson;
				totalNotPayerAddPersonPrices += parseFloat(line2.NOT_PAYED_PRICES_USR);

				if (parseInt(line2.IS_FUTURE) === 0) {
					++totalNotPayedAddPersonFinished;
					totalNotPayerAddPersonFinishedPrices += parseFloat(line2.NOT_PAYED_PRICES_USR);
				}

				if (reservationDate.getMonth() === targetMonth && reservationDate.getFullYear() === targetYear) {
					++totalNotPayedAddPersonPreviousMonth;
					totalNotPayerAddPersonPreviousMonthPrices += parseFloat(line2.NOT_PAYED_PRICES_USR);
				}
			}
		});
	}

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Editace uživatele</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeEdit();
									}}
								/>
							</div>
							<div className="popup_content_in_body popup_content_in_body--hidden-scrollbar">
								<div className="popup_content_in_body_in">
									<FormText type="text" label="Email" value={username} setValue={setUsername} ref={usernameRef} error={usernameError} />

									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Jméno" value={firstName} setValue={setFirstName} ref={firstNameRef} error={firstNameError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<FormText type="text" label="Příjmení" value={lastName} setValue={setLastName} ref={lastNameRef} error={lastNameError} />
									</div>

									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Přezdívka" value={nickname} setValue={setNickname} ref={nicknameRef} error={nicknameError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<div className="fl_r" style={{width: '60%'}}>
											<FormText type="text" label="Telefon" placeholder="111222333" maxLength="9" value={phone} setValue={setPhone} ref={phoneRef} error={phoneError} />
										</div>
										<div className="fl_l" style={{width: '36%'}}>
											<FormText type="text" label="Předv." value={prefix} placeholder="420" maxLength="3" setValue={setPrefix} ref={prefixRef} error={prefixError} />
										</div>
									</div>

									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="password" label="Heslo" value={password} setValue={setPassword} ref={passwordRef} error={passwordError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<FormText type="password" label="Znovu hesla" value={password2} setValue={setPassword2} ref={passwordRef2} error={passwordError2} />
									</div>
									<div className="zero h0" />

									<div className="fl_l" style={{width: '100%'}}>
										<FormText type="text" label="Pozvánka od mentora" value={parentPromoCode} setValue={setParentPromoCode} ref={parentPromoCodeRef} error={parentPromoCodeError} />
									</div>
									<div className="zero h0" />

									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Dluh" value={topayTotal} setValue={setTopayTotal} ref={topayTotalRef} error={topayTotalError} insertValues={topayInsertValues} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<FormDate label="Permice do" maxLength="10" readOnly value={payedtoDT} setValue={setPayedtoDT} ref={payedtoDTRef} error={payedtoDTError} />
									</div>
									<div className="zero h0" />
									
									<FormTextArea type="text" label="Čísla účtů (jeden na řádek)" height="6rem" value={accountNumber} setValue={setAccountNumber} ref={accountNumberRef} error={accountNumberError} />

									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Jednorázový vstup" value={entryPriceOne} setValue={setEntryPriceOne} ref={entryPriceOneRef} error={entryPriceOneError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										&nbsp;
									</div>
									<div className="zero h05" />

									<div className="fl_l" style={{width: '48%'}}>
										{parseInt(usrInfo.usrId) === 1 ? (
											<div className="fl_l mt_05 cr_p" onClick={(e) => setSysadminVal(e)}>
												<button type="button" className={`button check ${parseInt(sysadmin) === 1 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
												<span className="fl_l mt_02 fnt_orange fnt_b">
													Admin
												</span>
											</div>
										) : (
											<div>&nbsp;</div>
										)}
										<div className="zero h05" />
										
										<div className="fl_l mt_05 cr_p" onClick={(e) => setManagerVal(e)}>
											<button type="button" className={`button check ${parseInt(manager) === 1 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
											<span className="fl_l mt_02 fnt_orange fnt_b">
												Manager
											</span>
										</div>
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<div className="fl_l mt_05 cr_p" onClick={(e) => setInstructorVal(e)}>
											<button type="button" className={`button check ${parseInt(instructor) === 1 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
											<span className="fl_l mt_02">
												Instruktor
											</span>
										</div>
									</div>
									<div className="zero h1" />

									<FormTextArea type="text" label="Zpráva" height="11rem" value={message} setValue={setMessage} ref={messageRef} error={messageError} />

									{listNotPayedAddPerson.length > 0 ? (
										<div className="user-page__detail-card user-page__detail-card--danger user-page__detail-card--edit-unpaid">
											<div className="user-page__detail-card-head">
												<div className="user-page__detail-card-title">Nezaplacené vstupy</div>
												<div className="user-page__detail-card-value">{formatMoney(totalNotPayerAddPersonPrices)} ({totalNotPayedAddPerson}x)</div>
											</div>
											<div className="user-page__detail-card-body user-page__detail-card-body--edit-unpaid">
												<div className="user-page__unpaid-header user-page__unpaid-header--edit">
													<span>Datum</span>
													<span>Já</span>
													<span>Doprovod</span>
												</div>
												<div className="user-page__nested-list">{listNotPayedAddPerson}</div>
												<div className="user-page__edit-unpaid-summary">
													<div className="user-page__edit-unpaid-summary-row">
														<span className="user-page__edit-unpaid-summary-label">Celkem</span>
														<span className="user-page__edit-unpaid-summary-value">{formatMoney(totalNotPayerAddPersonPrices)} ({totalNotPayedAddPerson}x)</span>
													</div>
													<div className="user-page__edit-unpaid-summary-row">
														<span className="user-page__edit-unpaid-summary-label">Celkem uskutečněno</span>
														<span className="user-page__edit-unpaid-summary-value">{formatMoney(totalNotPayerAddPersonFinishedPrices)} ({totalNotPayedAddPersonFinished}x)</span>
													</div>
													<div className="user-page__edit-unpaid-summary-row">
														<span className="user-page__edit-unpaid-summary-label">Celkem předchozí měsíc</span>
														<span className="user-page__edit-unpaid-summary-value">{formatMoney(totalNotPayerAddPersonPreviousMonthPrices)} ({totalNotPayedAddPersonPreviousMonth}x)</span>
													</div>
												</div>
											</div>
										</div>
									) : (
										''
									)}

									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={isSubmitting} />
									<button
										type="button"
										className="button"
										onClick={() => {
											closeEdit();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
